export default __webpack_public_path__ + "static/media/chuter.f927fec2.jpg";